import $ from 'jquery';
import Backbone from 'backbone';
import app from '../../app';
import '../../jquery/jquery.resetOnEscape';

export default Backbone.View.extend({

    initialize: function () {
        this.form = this.$('form');
        //this.category = this.$('#header-search-category');
        this.queryField = this.$('#header-search-query');

        this.initAutocomplete();
        this.initKeyboardShortcuts();
    },


    initAutocomplete: function () {
        this.queryField.autocomplete({
            source: `${app.config.contextPath}/autocomplete`,
            open: () => this.queryField.addClass('has-suggestions'),
            close: () => this.queryField.removeClass('has-suggestions'),
            select: this.clickSelect
        });
    },

    initKeyboardShortcuts: function () {
        this.queryField.resetOnEscape();
    },

    onKeyFocusSearch: function (event) {
        event.preventDefault();

        if (!this.searchBarIsVisible()) {
            $('html, body').animate({ scrollTop: 0 }, 500);
        }

        this.queryField.focus();
    },

    clickSelect: function (event, ui) {
        if ($('#header-use-strictsearch').prop('checked')) {
            $('#header-search-query').val(`"${ui.item.value.trim()}"`);
        } else {
            $('#header-search-query').val(`${ui.item.value.trim()}`);
        }
        $('#header-search-submit').click();
    },

    searchBarIsVisible: function () {
        const docViewTop = $(window).scrollTop();
        const docViewBottom = docViewTop + $(window).height();

        const elemTop = this.queryField.offset().top;
        const elemBottom = elemTop + this.queryField.height();

        return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
    }
});


// WEBPACK FOOTER //
// ./views/layout/SearchElementController.js